import dayjs from 'dayjs';

export const prettyAddress = (...addr: string[]) => {
  return addr.filter((item) => item?.trim()).join(', ');
};

export const formatTime = (time: string) => {
  if (time && time !== '') {
    const defaultDate = dayjs();

    const combinedDateTime = `${defaultDate.format('YYYY-MM-DD')}T${time}`;

    const parsedTime = dayjs(combinedDateTime);

    const formattedTime = parsedTime.format('h:mm A');

    return formattedTime;
  } else {
    return '';
  }
};

export const formatDate = (time = undefined) => {
  if (!time) return "";
  const defaultDate = dayjs();
  return `${defaultDate.format("YYYY-MM-DD")}T${time}`;
};

export const capitalizeFirstLetter = (string: string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : string;
};

export const getCurrentDateTime = (stationTz?: string): Date => {
  return stationTz ? new Date(new Date().toLocaleString("en-US", { timeZone: stationTz })) : new Date();
};

export const formatStationTime = (time: string): Date => {
  const [hours, minutes, seconds] = time.split(':').map(Number);
  const now = new Date();
  now.setHours(hours, minutes, seconds || 0, 0);
  return now;
};

export const convertSeconds = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.round(seconds % 60);

  if (hours > 0) {
    return `${hours} hr${hours > 1 ? 's' : ''}`;
  } else if (minutes > 0) {
    return `${minutes} min${minutes > 1 ? 's' : ''}`;
  } else {
    return `${remainingSeconds} sec${remainingSeconds !== 1 ? 's' : ''}`;
  }
}

export function formatDistance(distanceInMeters: number): string {
  if (distanceInMeters < 0) {
    return 'Invalid distance';
  }

  const metersInMile = 1609.34;

  if (distanceInMeters < metersInMile) {
    return `${distanceInMeters.toFixed(0)} m`;
  } else {
    return `${(distanceInMeters / metersInMile).toFixed(2)} mi`;
  }
}

export function formatDuration(seconds: number): string {
  if (seconds < 0) return 'Invalid duration';

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hrs > 0) {
    return mins > 0 ? `${hrs}h ${mins}m` : `${hrs}h`;
  } else if (mins > 0) {
    return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
  } else {
    return `${secs}s`;
  }
}
